import { useQuery } from '@tanstack/react-query';
import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import { GetDmaCompanyPaymentPriceResponse } from '@upright/common/subscription/api-types';

const DMA_COMPANY_PAYMENT_PRICE_QUERY_KEY = ['dma-company-payment-price'];

export function useDmaCompanyPaymentPrice() {
  return useQuery<GetDmaCompanyPaymentPriceResponse>({
    queryKey: DMA_COMPANY_PAYMENT_PRICE_QUERY_KEY,
    queryFn: async () => {
      return await fetchOrThrow<GetDmaCompanyPaymentPriceResponse>('/subscription/dma-company-payment-price', 'GET');
    },
  });
}
